var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpiritualWellBeingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#E7F8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 23.06C29.2592 23.06 30.28 22.0392 30.28 20.78C30.28 19.5208 29.2592 18.5 28 18.5C26.7408 18.5 25.72 19.5208 25.72 20.78C25.72 22.0392 26.7408 23.06 28 23.06Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.38 27.11C29.72 27.45 29.72 28 29.38 28.34L27.99 29.73L26.6 28.34C26.26 28 26.26 27.45 26.6 27.11C26.94 26.77 27.49 26.77 27.83 27.11L27.98 27.26L28.14 27.1C28.48 26.76 29.03 26.76 29.37 27.1L29.38 27.11Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.52 34.54C18.99 34.81 18.66 35.35 18.66 35.94C18.66 36.81 19.36 37.51 20.23 37.51H28",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.98 32.78L19.52 34.54",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.48 34.54C37.01 34.81 37.34 35.35 37.34 35.94C37.34 36.81 36.64 37.51 35.77 37.51H28",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.02 32.78L36.48 34.54",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3201 34.64L28.0001 35.6L23.6801 34.64",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.86 29.3L33.06 25.81C32.9 25.52 32.62 25.33 32.32 25.29V25.27L31.34 25.03L29.78 24.66C28.61 24.38 27.39 24.38 26.22 24.66L24.66 25.03L23.68 25.27V25.29C23.38 25.33 23.1 25.52 22.94 25.81L21.14 29.3C20.96 29.65 20.87 30.03 20.87 30.4C20.87 30.94 21.06 31.45 21.38 31.87C21.7 32.28 22.18 32.6 22.74 32.73L22.98 32.78L24.66 33.15L25.37 33.31L27.78 33.84H27.82C27.93 33.87 28.05 33.87 28.18 33.84H28.22L30.63 33.31L31.34 33.15L33.02 32.78L33.26 32.73C33.82 32.6 34.3 32.28 34.62 31.87C34.94 31.45 35.13 30.94 35.13 30.4C35.13 30.03 35.04 29.65 34.86 29.3ZM24.66 31.1L23.18 30.77C23.08 30.75 23.01 30.7 22.96 30.64C22.87 30.51 22.85 30.37 22.92 30.22L24.66 26.85V31.1ZM33.04 30.64C32.99 30.7 32.92 30.75 32.82 30.77L31.34 31.1V26.85L33.08 30.22C33.15 30.37 33.13 30.51 33.04 30.64Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8201 30.77L28.0001 31.85L23.1801 30.77",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.16 19.44C23.6 19.96 23.71 20.64 23.51 21.24C22.89 21.33 22.24 21.1 21.81 20.58C21.38 20.06 21.26 19.38 21.46 18.79C22.09 18.7 22.73 18.92 23.17 19.44H23.16Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.92 24.4C20.48 24.5 20.92 24.88 21.12 25.37C20.77 25.76 20.23 25.97 19.66 25.87C19.09 25.77 18.66 25.39 18.46 24.91C18.81 24.51 19.35 24.31 19.92 24.41V24.4Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M32.84 19.44C32.4 19.96 32.29 20.64 32.49 21.24C33.11 21.33 33.76 21.1 34.19 20.58C34.62 20.06 34.74 19.38 34.54 18.79C33.91 18.7 33.27 18.92 32.83 19.44H32.84Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36.08 24.4C35.52 24.5 35.08 24.88 34.88 25.37C35.23 25.76 35.77 25.97 36.34 25.87C36.91 25.77 37.34 25.39 37.54 24.91C37.19 24.51 36.65 24.31 36.08 24.41V24.4Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpiritualWellBeingIcon);
export default __webpack_public_path__ + "static/media/spiritual_well_being_icon.cff51e81cf5fc13f746d897fe31698e7.svg";
export { ForwardRef as ReactComponent };